'use client';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { HeaderControlButton } from '@//components/Header';
import { PopoverMenu, PopoverMenuLink } from '@//components/PopoverMenu';

interface MobileMenuButtonProps {
  navigationLinks: Array<{
    href: string;
    label: string;
  }>;
  ariaLabel: string;
  triggerLabel: string;
  triggerTitle: string;
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({
  navigationLinks,
  ariaLabel,
  triggerLabel,
  triggerTitle,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PopoverMenu
      headerMenu={true}
      sideOffset={8}
      side="bottom"
      align="end"
      ariaLabel={ariaLabel}
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={
        <HeaderControlButton
          label={triggerLabel}
          title={triggerTitle}
          testId="header-button-mobile-menu"
          hiddenMd={true}
        >
          {isOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </HeaderControlButton>
      }
    >
      {navigationLinks.map((link, index) => (
        <PopoverMenuLink
          key={link.href}
          href={link.href}
          label={link.label}
          testId={`header-mobile-main-navigation-link-${index + 1}`}
        />
      ))}
    </PopoverMenu>
  );
};
